import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import { FacebookShare, PageSummary } from '../index';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import { filterByTypename } from '../../utils/graphql';
import useBasePageQuery from '../../hooks/useBasePageQuery';
import { useFlags } from '../../hooks/useFlags';

type TeamSummaryProps = {
  showSummary: boolean;
};

const TeamSummary: FunctionComponent<TeamSummaryProps> = ({ showSummary }) => {
  const basePageData = useBasePageQuery();
  const { enableDonateToTeam } = useFlags();
  const { currentUrl } = useNotNullableContext(PageMetaContext);

  if (!basePageData.data?.page) {
    return null;
  }

  const { relationships, title } = basePageData.data.page;
  const beneficiaries = relationships?.beneficiaries;
  if (!beneficiaries) {
    return null;
  }
  const charities = filterByTypename(beneficiaries.nodes, 'Charity');
  if (showSummary && beneficiaries.totalCount >= 1) {
    return (
      <PageSummary
        pagetitle={title}
        pagesubtitle={
          <Trans i18nKey="team.fundraisingFor" count={beneficiaries.totalCount}>
            Team fundraising for{' '}
            <span className="jg-text--regular">
              {{ charityName: charities[0].name }}
            </span>
          </Trans>
        }
        ctas={
          enableDonateToTeam ? (
            <div className="row row--no-gutter">
              <div className="col-sm-6 jg-space-prxs">
                <a
                  href={`${currentUrl}/donate`}
                  className="jg-btn"
                  data-qa="team-donate"
                >
                  Donate
                </a>
              </div>
              <div className="col-sm-6 jg-space-plxs">
                <FacebookShare url={currentUrl} showPrefix />
              </div>
            </div>
          ) : (
            <FacebookShare url={currentUrl} showPrefix />
          )
        }
      />
    );
  }
  return null;
};

export default TeamSummary;
